import { useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';
import styles from './data-explorer-file-drop.module.css';
import { onOSFileDrag } from './files-browser.utils';

interface IExplorerDndUploadProps {
  onDrop: (file: File[], nodeid: string) => void;
  itemName: string;
}
export const DataExplorerFileDrop = ({ onDrop, itemName }: IExplorerDndUploadProps) => {
  const [dropTextVisible, setDropTextVisible] = useState(false);
  const { t } = useTranslation();

  const handleDragEnter = onOSFileDrag((event) => {
    event.preventDefault();
    event.stopPropagation();
    setDropTextVisible(true);
  });
  const handleDragLeave = onOSFileDrag((event) => {
    event.preventDefault();
    event.stopPropagation();
    setDropTextVisible(false);
  });
  const handleDrop = onOSFileDrag((event) => {
    event.preventDefault();
    event.stopPropagation();

    onDrop(Array.from(event.dataTransfer?.files), '');
    setDropTextVisible(false);
  });

  return (
    <>
      {dropTextVisible && (
      <div className={styles.dropText}>
        {t(translations.importExport_dropToUpload, { hierarchyItem: itemName, interpolation: { escapeValue: false } })}
      </div>
      )}
      <div
        className={cx(styles.dropZone, dropTextVisible ? styles.visible : '')}
        id="drop_zone"
        onDrop={(event) => handleDrop(event)}
        onDragEnter={event => handleDragEnter(event)}
        onDragLeave={event => handleDragLeave(event)}
      />
    </>
  );
};
